import { Component, Input, OnInit, } from '@angular/core';
// tslint:disable-next-line:import-blacklist
import { UntypedFormControl, UntypedFormGroup, NgForm, Validators } from '@angular/forms';
import { FcGenericListItemDto } from 'webcommon/shared';

@Component({
  selector: 'fc-generic-list',
  templateUrl: './fc-generic-list.component.html',
})
export class FcGenericListComponent implements OnInit {

  @Input() baseId: string;
  @Input() form: NgForm;
  @Input() genericListFormGroup: UntypedFormGroup;
  @Input() genericListItem: FcGenericListItemDto;

  externalIdControl = new UntypedFormControl();
  nameControl = new UntypedFormControl();
  inactiveControl = new UntypedFormControl();
  userDefinedControl = new UntypedFormControl();
  notesControl = new UntypedFormControl();

  ngOnInit() {
    this.loadForm();
  }

  loadForm() {
    this.externalIdControl.setValidators([Validators.maxLength(25)]);
    this.externalIdControl.setValue(this.genericListItem.ExternalId);
    this.genericListFormGroup.addControl('externalIdControl', this.externalIdControl);

    this.nameControl.setValidators([Validators.maxLength(50), Validators.required]);
    this.nameControl.setValue(this.genericListItem.Name);
    if (!this.genericListItem.UserDefined) {
      this.nameControl.disable();
    }
    this.genericListFormGroup.addControl('nameControl', this.nameControl);

    this.notesControl.setValue(this.genericListItem.Notes);
    this.genericListFormGroup.addControl('notesControl', this.notesControl);

    this.inactiveControl.setValue(this.genericListItem.Inactive);
    this.genericListFormGroup.addControl('inactiveControl', this.inactiveControl);

    this.userDefinedControl.setValue(this.genericListItem.UserDefined);
    this.userDefinedControl.disable();
    this.genericListFormGroup.addControl('userDefinedControl', this.userDefinedControl);
  }
}
